import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const LeadDashboardCreateModalUI = ({ context, successMsg, errorList, setErrorList,
  createEntryMode, submitted, onSubmit, onCancelClick,
  originatorList, salesChannelList,

  brandName, onBrandNameChange, brandNameError, setBrandNameError,
  accountNamePan, onAccountNamePanChange, accountNamePanError, setAccountNamePanError,
  comments, onCommentsChange, commentsError, setCommentsError,
  manualLoanAmount, onManualLoanAmountChange, manualLoanAmountError, setManualLoanAmountError,
  poc, onPocChange, pocError, setPocError,
  designation, onDesignationChange, designationError, setDesignationError,
  phoneNumber, onPhoneNumberChange, phoneNumberError, setPhoneNumberError,
  email, onEmailChange, emailError, setEmailError,
  originatorUserId, onOriginatorUserIdChange, originatorUserIdError, setOriginatorUserIdError,
  channel, onChannelChange, channelError, setChannelError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Add Lead'
    buttonLabel='Add'
    cancelLabel='Cancel'
    isOpen={createEntryMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <div className='ld_modal_scroll_body'>
    <InputTextSF type='text' name='brandName' label='Brand Name'
      value={brandName} onChange={onBrandNameChange}
      error={brandNameError} setError={setBrandNameError}
    />
    <InputTextSF type='text' name='accountNamePan' label='Account Name (as on PAN)'
      value={accountNamePan} onChange={onAccountNamePanChange}
      error={accountNamePanError} setError={setAccountNamePanError}
    />
    <InputTextAreaSF type='text' name='comments' label='Comments'
      value={comments} onChange={onCommentsChange}
      error={commentsError} setError={setCommentsError}
    />
    <InputTextSF type='price' name='manualLoanAmount' label='Loan Amount'
      value={manualLoanAmount} onChange={onManualLoanAmountChange}
      error={manualLoanAmountError} setError={setManualLoanAmountError}
    />
    <InputTextSF type='text' name='poc' label='POC (Client End)'
      value={poc} onChange={onPocChange}
      error={pocError} setError={setPocError}
    />
    <InputTextSF type='text' name='designation' label='Designation'
      value={designation} onChange={onDesignationChange}
      error={designationError} setError={setDesignationError}
    />
    <InputTextSF type='text' name='phoneNumber' label='Phone No.'
      value={phoneNumber} onChange={onPhoneNumberChange}
      error={phoneNumberError} setError={setPhoneNumberError}
    />
    <InputTextSF type='text' name='email' label='E-Mail'
      value={email} onChange={onEmailChange}
      error={emailError} setError={setEmailError}
    />
    <InputSelectSF name='originatorUserId' label='Originator'
      value={originatorUserId} onChange={onOriginatorUserIdChange}
      error={originatorUserIdError} setError={setOriginatorUserIdError}
      optionList={originatorList}
    />
    <InputSelectSF name='channel' label='Channel'
      value={channel} onChange={onChannelChange}
      error={channelError} setError={setChannelError}
      optionList={salesChannelList}
    />
    </div>
  </ModalFormUI>
  
export default LeadDashboardCreateModalUI